// src/components/UI/components/DropdownMenu/DropdownMenuSubMenuTrigger.tsx

import { SubTrigger } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { cx } from '../../lib/utils';
import { RiArrowRightSLine } from '@remixicon/react';

const DropdownMenuSubMenuTrigger = forwardRef<
  React.ElementRef<typeof SubTrigger>,
  React.ComponentPropsWithoutRef<typeof SubTrigger>
>(({ className, children, ...props }, forwardedRef) => (
  <SubTrigger
    ref={forwardedRef}
    className={cx(
      // base
      'relative flex cursor-default select-none items-center rounded py-2 pl-4 pr-2 outline-none transition-colors font-accent sm:text-sm',
      // text color
      'text-revving-content dark:text-darkRevving-content',
      // disabled
      'data-[disabled]:pointer-events-none data-[disabled]:text-gray-400 data-[disabled]:hover:bg-none dark:data-[disabled]:text-gray-600',
      // focus
      'focus-visible:bg-revving-brand-faint data-[state=open]:bg-revving-brand-faint focus-visible:dark:bg-darkRevving-brand-faint data-[state=open]:dark:bg-darkRevving-brand-faint',
      // hover
      'hover:text-revving-content-strong hover:bg-revving-brand-faint hover:dark:text-darkRevving-content-strong hover:dark:bg-darkRevving-brand-faint',
      //
      className,
    )}
    {...props}
  >
    {children}
    <RiArrowRightSLine
      className="ml-auto size-4 shrink-0 dark:text-gray-500"
      aria-hidden="true"
    />
  </SubTrigger>
));
DropdownMenuSubMenuTrigger.displayName = 'DropdownMenuSubMenuTrigger';

export { DropdownMenuSubMenuTrigger };
